import { Box } from '@mui/material';
import React from 'react';
import useColor from '../../../hooks/site/useColor';

/**
 *
 * @deprecated использовать нужно stickyHeader
 */
export default function MyTableBody({ children, maxHeight, displayTable = 'table' }) {
  const { scrollbarColor } = useColor();

  return (
    <Box
      component={'tbody'}
      sx={{
        display: 'block',
        maxHeight: maxHeight,
        overflow: 'auto',
        scrollbarColor: `${scrollbarColor} transparent`,
        scrollbarWidth: 'auto',
        '& tr': {
          display: displayTable,
          width: '100%',
          tableLayout: 'fixed'
        }
      }}>
      {children}
    </Box>
  );
}
